import React, { useState, ChangeEvent } from 'react';

import { ActionButton } from 'components/ModelButton';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';

import UserImg from 'img/user-green-report.svg';

import { ReportItem } from './interface';
import { DateOutputStr } from 'utils/DateOutput';
import { calcDataFrom, calcDataTo } from 'utils/Date';

import './styles.scss';
import PeriodDateToInput from 'components/PeriodDateToInput';

export const ReportDashItemWithCalendar: React.FC<ReportItem> = (props) => {
  const { description, trackItem, trackName, action } = props;

  const [period, setPeriod] = useState({
    from: getMinDate() ? DateOutputStr(getMinDate().toISOString(), 'yyyy-MM-dd') : '',
    to: getMaxDate() ? DateOutputStr(getMaxDate().toISOString(), 'yyyy-MM-dd') : '',
  });
  const [newDate, setNewDate] = useState('');

  function getMinDate() {
    const minDate = new Date(new Date().toDateString());
    minDate.setMonth(minDate.getMonth() - 3);
    return minDate;
  }

  function getMaxDate() {
    return new Date(new Date().toDateString());
  }

  const handleSelectDateEnd = (event: ChangeEvent<HTMLInputElement>) => {
    setPeriod({ ...period, from: event.target.value });
    setNewDate('end');
  };

  const handleExportData = async () => {
    await action(period);
  };

  return (
    <Row className="flex-1 bg-white mx-1 mt-3 py-4 justify-center border-radius-report">
      <Row className="bg-green p-4 justify-between flex-column">
        <Text>{description}</Text>

        <Column className="flex-1 mr-md-2 w-md-100 mt-md-3 mt-40">
          <Text className=" mb-1 color-blue-gray" size={12} weight="bold">
            Período
          </Text>
          <Row className="flex-1 align-center">
            <input
              className="flex-1"
              value={period.from}
              onChange={handleSelectDateEnd}
              type="date"
              max={period.to}
              placeholder="Início"
              onBlur={() => calcDataTo(period, newDate, setPeriod)}
            />
            <Text className="mx-1 color-blue-gray" size={12} weight="bold"> a </Text>
            <PeriodDateToInput
              setNewData={setNewDate}
              onBlur={() => calcDataFrom(period, newDate, setPeriod)}
              className="flex-1"
              period={period}
              setPeriod={setPeriod}
              placeHolder={"Fim"}
            />
          </Row>
        </Column>

        <ActionButton
          trackName={trackName}
          trackItem={trackItem}
          textButton="Exportar Dados"
          action={handleExportData}
        />

        <Row className="bg-white ps-absolute">
          <img title='user-img' src={UserImg} />
        </Row>
      </Row>
    </Row>
  );
};